export default defineNuxtPlugin(() => {
  if (process.client) {
    // 在客户端注入样式修复
    const style = document.createElement('style')
    style.textContent = `
      .el-radio__inner:after {
        width: 10px !important;
        height: 10px !important;
        top: 50% !important;
        left: 50% !important;
        background: #666 !important;
        transition: none !important;
        border-radius: 50% !important;
        content: "" !important;
        position: absolute !important;
      }
      
      .el-radio__input.is-checked .el-radio__inner:after {
        transform: translate(-50%, -50%) scale(1) !important;
      }
      
      .el-radio__input.is-checked .el-radio__inner {
        border-color: #666 !important;
        background: #fff !important;
      }
    `
    document.head.appendChild(style)
  }
}) 